import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

export default function Header() {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };
    const [name, setName] = useState('');
    const [mobile, setMobile] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
        // // Show the modal 10 seconds after the page loads
        // const timer = setTimeout(() => {
        //     const modal = new window.bootstrap.Modal(document.getElementById('myModal'));
        //     modal.show();
        // }, 10000); // 10000ms = 10 seconds

        // Cleanup the timer on component unmount
        // return () => clearTimeout(timer);
    }, []);



    return (
        <>
            <div className="header header-light">
                <div className="container">
                    <nav id="navigation" className="navigation navigation-landscape">
                        <div className="nav-header">
                            <a className="nav-brand" href="#">
                                <img src="assets/img/ncc_logo2.png" className="logo" alt="NCC Logo" />
                            </a>
                            <div className="nav-toggle" onClick={toggleMenu}>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                        <div
                            className={`nav-menus-wrapper ${menuOpen ? 'active' : ''}`}
                            style={{ transitionProperty: 'none' }}
                        >
                            <ul className="nav-menu">
                                <li className="active">
                                    <Link to={'/'}>Home</Link>
                                </li>
                                <li>
                                    <Link to={"/about"}>About us</Link>
                                </li>
                                <li>
                                    <Link to={"/Course"}>Courses</Link>
                                </li>
                                <li>
                                    <Link to={"/Gallery"}>Gallery</Link>
                                </li>
                                <li>
                                    <Link to={"/Contact"}>Contact</Link>
                                </li>
                                <li className="login_click light">
                                    <a href="#" data-bs-toggle="modal" data-bs-target="#myModal">
                                        Enroll Now
                                    </a>
                                </li>
                            </ul>
                            {/* <ul className="nav-menu nav-menu-social align-to-right">

                            </ul> */}
                        </div>
                    </nav>
                </div>
            </div>
            {/* End Navigation */}
            <div className="clearfix" />
            {/* MOdel */}
            <div className="modal" id="myModal" tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        {/* Modal Header */}
                        <div className="modal-header">
                            <h4 className="modal-title">Inquiry Form</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        {/* Modal Body */}
                        <div className="modal-body">
                            <form id="inquiryForm" >
                                <div className="mb-2">
                                    <label htmlFor="name" className="form-label">Name</label>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        id="name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        placeholder="Enter your name"
                                        required
                                    />
                                </div>
                                <div className="mb-2">
                                    <label htmlFor="mobile" className="form-label">Mobile</label>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        id="mobile"
                                        value={mobile}
                                        onChange={(e) => setMobile(e.target.value)}
                                        placeholder="Enter your mobile number"
                                        required
                                    />
                                </div>
                                <div className="mb-2">
                                    <label htmlFor="message" className="form-label">Message</label>
                                    <textarea
                                        className="form-control form-control-sm"
                                        id="message"
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        placeholder="Enter your message"
                                        rows="3"
                                        required
                                    ></textarea>
                                </div>
                            </form>
                        </div>
                        {/* Modal Footer */}
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="submit"
                                form="inquiryForm"
                                className="btn btn-primary"
                            >
                                Submit Inquiry
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* MOdel // */}
        </>

    )
}
